/* eslint-env browser, jquery */
/* globals window */

'use strict';

window.Backbone = require('backbone');

window.Backbone.$ = window.$;

require('../../../modules/deal/frontend/event_pipe');
require('../../../modules/tracking/frontend/initializer');
require('../../../modules/buy_button/desktop_2016/frontend/buy_button');
require('../../../modules/buy_button/desktop_2016/frontend/multi_option_modal');
require('../../../modules/carousel/frontend/desktop');
require('../../../modules/deal/frontend/channel_tabs');
require('../../../modules/deal/frontend/controller');
require('../../../modules/deal/frontend/external_links');
require('../../../modules/gift_button/frontend/gift');
require('../../../modules/external_deal/frontend/external_deal');
require('../../../modules/sharing/frontend/facebook');
require('../../../modules/deal/frontend/deal_lazy_loader');
require('../../../modules/deal/frontend/deal_track_content_loaded');
require('../../../modules/variations/frontend/variations-widget');
require('../../../modules/deal_highlights/frontend/deal_highlights');
require('../../../modules/ad_unit/frontend/ad_unit_lazy_loader');
require('../../../modules/wishlist_button/frontend/wishlist');
require('../../../modules/applepay/desktop2016/frontend/main');
require('../../../modules/member_only/frontend/main');
require('../scripts/vendor_modules/fix-a11y');
require('./async_initializer');
require('es6-promise').polyfill();

// external packages
require('groupon-iframe-login');

// performance experiment tracking
const sendExperimentTrackyMessage = require('../../../modules/experiments/frontend/sendExperimentTrackyMessage');

$(window).load(() => {
  const Groupon = window.Groupon;
  Groupon.Performance.pageReady();
  if (window.AdUnitLazyLoader != null) {
    window.AdUnitLazyLoader.load();
  }
  return sendExperimentTrackyMessage();
});



// WEBPACK FOOTER //
// ./core/frontend/webpack/base.js